import * as m from "./../../dist/es2015/flow.js";
export const am5flow = m;